import React from "react";
import { QueryStatus } from "@shared/types";

export const ExtraDetailsDrawerContext = React.createContext<
  | {
      setTabQueries: (
        tabKey: string,
        queries: QueryStatus[] | undefined
      ) => void;
    }
  | undefined
>(undefined);
